import { Row, Col, Alert, Fade } from 'reactstrap';

function RequestFailed(props) {
  return <Row><Col md="12"><Alert color="danger">Request Failed. Error {props.errorCode}</Alert></Col></Row>
}

export default RequestFailed;